import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IOrthodonticReferralCompletionReason, IOrthodonticReferralCompletion, IForwardOrthodonticReferral, IOrthodonticReferralTreatmentNotNeededReason, IOrthodonticReferralConditionCode, IOrthodonticReferralAnswer } from "../models/IOrthodonticReferral";
import { ICareProvider } from "../models/ICareProvider";

export class OrthodonticReferralResponseApi extends ApiClient {

    constructor(auth: AuthContextModel) {
        super(auth);
    }

    requestCompletion(data: IOrthodonticReferralCompletion, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralResponse/requestCompletion`, data, success, error, final);
    }

    getOrthodonticReferralCompletionReasons(success: (data: IOrthodonticReferralCompletionReason[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralResponse/completionReasons`, success, error, final);
    }

    forwardOrthodonticReferral(data: IForwardOrthodonticReferral, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralResponse/forward`, data, success, error, final);
    }

    getCareProvidersWithActiveSelectionAreaContracts(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralResponse/careProvidersWithActiveSelectionAreaContracts`, success, error, final);
    }

    createPatientViewing(orthodonticReferralId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralResponse/createPatientViewing/${orthodonticReferralId}`, undefined, success, error, final);
    }

    saveOrthodonticReferralAnswer(data: IOrthodonticReferralAnswer, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralResponse/saveAnswer`, data, success, error, final);
    }

    saveOrthodonticReferralAnswerAndClose(data: IOrthodonticReferralAnswer, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralResponse/saveAnswerAndClose`, data, success, error, final);
    }

    sendToProvningskonsult(orthodonticReferralId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralResponse/sendToProvningskonsult/${orthodonticReferralId}`, undefined, success, error, final);
    }
}